import { cn } from '@/utils/lib/cn';
import { type ReactNode } from 'react';
import { Link as ReactRouterLink } from 'react-router';

import { ButtonProps, buttonVariants } from './Button';

interface CustomLinkProps
  extends Omit<React.ComponentProps<typeof ReactRouterLink>, 'to'>,
    Pick<ButtonProps, 'variant' | 'size'> {
  children: ReactNode;
  href: string;
  className?: string;
  disabled?: boolean;
}

function Link({
  children,
  className,
  disabled = false,
  href,
  size,
  variant = 'ghost',
  ...props
}: CustomLinkProps) {
  return (
    <ReactRouterLink
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : undefined}
      className={cn(
        buttonVariants({ size, variant }),
        className,
        disabled && 'pointer-events-none cursor-not-allowed opacity-50',
      )}
      {...props}
      to={href}
    >
      {children}
    </ReactRouterLink>
  );
}

export { Link };
